<template>
  <div class="overlapping-thumbnails">
    <thumbnail
      v-for="user in usersList"
      :key="user.id"
      v-tooltip="user.name"
      :title="user.name"
      :src="user.thumbnail"
      :username="user.name"
      :has-border="true"
      :size="size"
      :class="`overlapping-thumbnail gap-${gap}`"
    />
    <span
      v-if="showMoreThumbnailsCount"
      v-tooltip="$t('CONVERSATION_PARTICIPANTS.SEE_ALL_PARTICIPANTS')"
      class="thumbnail-more-text"
      style="cursor:pointer"
      @click="$emit('show-all')"
    >
      {{ moreThumbnailsText }}
    </span>
  </div>
</template>
<script>
import Thumbnail from './Thumbnail';

export default {
  components: {
    Thumbnail,
  },
  props: {
    usersList: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: '24px',
    },
    showMoreThumbnailsCount: {
      type: Boolean,
      default: false,
    },
    moreThumbnailsText: {
      type: String,
      default: '',
    },
    gap: {
      type: String,
      default: 'normal',
      validator(value) {
        // The value must match one of these strings
        return ['normal', '', 'tight'].includes(value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.overlapping-thumbnails {
  display: flex;

  ::v-deep .avatar-container div {
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-normal);
    line-height: var(--space-two);
  }
}

.overlapping-thumbnail {
  position: relative;
  box-shadow: var(--shadow-small);

  &:not(:first-child) {
    margin-left: var(--space-minus-small);
  }

  .gap-tight {
    margin-left: var(--space-minus-small);
  }
}

.thumbnail-more-text {
  display: inline-flex;
  align-items: center;
  position: relative;

  margin-left: var(--space-minus-small);
  padding: 0 var(--space-small);
  box-shadow: var(--shadow-small);
  background-color: var(--conversa2-blue-200-color);
  border-radius: var(--space-giga);
  border: 1px solid var(--white);

  color: var(--conversa2-neutral-800-color);
  font-size: var(--font-size-small);
  line-height: 20px;
}
</style>
